// @ts-strict-ignore
import React from 'react'
import { Image, Button, Slider } from '../../../atoms'
import { connect } from 'react-redux'
import { brand } from '@r/app-selectors'

interface Item {
  altValue: string
  imgUrl: string
  title: string
  redirectionUrl: string
}

export interface GuidesModuleProps {
  name: string
  variant: string
  rawName: string
  sys: { id: string }
  jsonBody: {
    title: string
    subTitle: string
    moreGuidesRedirectUrl: string
    primaryGuide: {
      altValue: string
      imgUrl: string
      title: string
      redirectionUrl: string
    }
    secondaryGuides: Item[]
  }
  showHeader: boolean
  brand: 'money' | 'uswitch'
}

const GuidesModule = ({
  jsonBody,
  name,
  variant,
  rawName,
  sys,
  showHeader,
  brand,
}: GuidesModuleProps) => {
  try {
    const cards = [jsonBody.primaryGuide, ...jsonBody.secondaryGuides]
    return (
      <div id={name} sx={{ marginBottom: 48 }}>
        <section className='Guides' data-controller='platinum-carousel'>
          {showHeader && jsonBody.title && <h2 className='Guides__title'>{jsonBody.title}</h2>}
          {jsonBody.subTitle && <div className='Guides__subHeader'>{jsonBody.subTitle}</div>}
          <div className='Guides__Container'>
            <div
              className='Guides__Cards'
              data-platinum-carousel-target='carouselContainer'
              data-action='scroll->platinum-carousel#handleScroll'
            >
              {cards.map((card, index) => {
                return (
                  <div
                    key={index}
                    className={`Guides__Card`}
                    data-platinum-carousel-target='carouselCard'
                    /* eslint-disable camelcase */
                    data-scroll-tracking={JSON.stringify({
                      component_category: 'platinum-component',
                      component_id: sys?.id,
                      component_name: 'Guides',
                      contentful_name: rawName,
                      contentful_variant: variant,
                      additionalProps: { title: card.title },
                    })}
                  >
                    <div className='Guides__Card__header'>
                      <a href={card.redirectionUrl}>
                        <Image
                          src={card.imgUrl}
                          alt={card.altValue}
                          variant='xlarge'
                          critical={false}
                        />
                      </a>

                      <div className='Guides__Card__header--title'>{card.title}</div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div className='Guides__nav'>
            <Slider cards={cards} variant={'primary'} />
          </div>
          <div className='Guides__cta'>
            <Button
              variant={brand === 'money' ? 'tertiary' : 'secondary'}
              size='lg'
              dataClickTracking={{
                component_category: 'platinum-component',
                component_id: sys?.id,
                component_name: 'guidesModule',
                contentful_name: rawName,
                contentful_variant: variant,
                additionalProps: { text: 'Find more guides here' },
              }}
              href={jsonBody.moreGuidesRedirectUrl}
            >
              Find more guides here
            </Button>
          </div>
        </section>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(GuidesModule)
